import { DOMAIN } from 'config';

export const pathConverter = (path: string = '') => {
  return `${DOMAIN}/?mode=headerless#${path}`;
};

export const iframePaths = [
  '/item', // Controlled by ItemsTableView feature flag
  '/style',
  '/report',
  '/dashboard',
  //'/analytics', // disabled due to flex monster not working in iframe
  '/marketing',
  '/order',
  '/compliance',
  '/admin',
];

// Regex patterns for paths that should show iframe (detail/sub-routes)
export const iframePathPatterns = [/^\/item\/\d+/, /^\/style\/\d+/];

export const shouldNavigate = (iframePath: string, reactPath: string): string => {
  try {
    let iframeUrl = iframePath || '';
    iframeUrl = iframeUrl.replace(/^#\/|^#|^\//, '');
    const reactUrl = reactPath.replace(/^\//, '');
    if (iframeUrl !== reactUrl) {
      return iframeUrl;
    }
  } catch (e) {
    return '';
  }
  return '';
};

export const checkIframeOrigin = (origin: string): boolean => {
  if (origin === DOMAIN) {
    return true;
  }
  if (origin === window.location.origin) {
    return true;
  }
  return false;
};
